/* Productpagina: bundels (1/2/3 potjes) + maandabonnement. Draait na goldgums.js. */
(() => {
  document.querySelectorAll('[data-gg-pdp]').forEach((root) => {
    const opts = [...root.querySelectorAll('[data-gg-purchase-opt]')];
    if (!opts.length) return;
    const qty = root.querySelector('input[name="quantity"]');
    const plan = root.querySelector('[data-gg-selling-plan]');
    const sp = root.querySelector('[data-gg-sticky-price]');
    const sm = root.querySelector('[data-gg-sticky-mode]');
    const isPlan = (o) => !!o.querySelector('[data-gg-plan-select]');
    const tidy = () => {
      opts.forEach((o) => { const s = o.querySelector('[data-gg-plan-select][data-single]'); if (s) s.hidden = true; });
      const act = opts.find((o) => o.classList.contains('is-active'));
      if (!act) return;
      const bp = act.querySelector('[data-gg-bundle-price]');
      if (sp && bp) sp.textContent = bp.textContent;
      if (sm && act.dataset.mode) sm.textContent = act.dataset.mode;
    };
    opts.forEach((o) => {
      const r = o.querySelector('[data-gg-purchase]');
      r?.addEventListener('change', () => { if (qty && o.dataset.qty) qty.value = o.dataset.qty; setTimeout(tidy); });
    });
    const sync = () => {
      if (!qty || (plan && plan.value)) return setTimeout(tidy);
      const q = String(Math.min(3, parseInt(qty.value, 10) || 1));
      const o = opts.find((x) => x.dataset.qty === q && !isPlan(x));
      const r = o && o.querySelector('[data-gg-purchase]');
      if (r && !r.checked) { const keep = qty.value; r.checked = true; r.dispatchEvent(new Event('change')); qty.value = keep; }
      setTimeout(tidy);
    };
    root.querySelectorAll('[data-gg-qty]').forEach((b) => b.addEventListener('click', () => setTimeout(sync)));
    qty?.addEventListener('change', sync);
    tidy();
  });
})();